import React from 'react'
import { Box, RoundedBox, Text } from '@react-three/drei';
import useStore from '../hooks/Store';

export const FrontPanel = ({ ...props }) => {
    const { position = [0, 1.53, 1.26], rotation = [0.2, 0, 0] } = props;
    const args = [.8, 0.1, 0.4];
    const { playerScore, highScore, countdown } = useStore();
    return (
        <group position={position} rotation={rotation}>
            {/* Main panel */}
            <RoundedBox castShadow radius={0.01}  args={args} segments={1} smoothness={2}>
                <meshPhongMaterial color={0xd1dad1}  />
            </RoundedBox>
            
            {/* LED display */}
            <Box args={[0.4, 0.01, 0.2]} position={[0, 0.05, 0.05]} >
                <meshPhongMaterial color={0x0f0f0f} specular={0x333333} shininess={20} />
            </Box>

            {/* LED info text */}
            <Text font='dotty.ttf' fontSize={0.1} color={'red'} position={[0, .057, 0]} rotation={[-Math.PI / 2, 0, 0]} >Score: {playerScore}</Text>
            {countdown > 0 && <Text font='dotty.ttf' fontSize={0.1} color={'red'} position={[0, .057, 0.1]} rotation={[-Math.PI / 2, 0, 0]} >
                Time: {countdown}
            </Text>}
            {countdown === 0 && <Text font='dotty.ttf' fontSize={0.1} color={'red'} position={[0, .057, 0.1]} rotation={[-Math.PI / 2, 0, 0]} >
                Highscore: {highScore}
            </Text>}

            {/* Button labels */}
            <Text font='erica.ttf' fontSize={0.04} color={0xf030a0} position={[-.3, .051, 0.13]} rotation={[-Math.PI / 2, 0, 0]}>START</Text>
            <Text font='erica.ttf' fontSize={0.04} color={0xf030a0} position={[.3, .051, 0.13]} rotation={[-Math.PI / 2, 0, 0]}>SHOT</Text>
        </group >
    )
}
export default FrontPanel;